import {
	Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
	Enum_Componentinternaldefaultmoduleoptions_Padding,
	GetLocalSitemapQuery
} from 'api/graphql-types';
import { GetServerSideProps } from 'next';
import client from 'api/apollo-client';
import { getServerPageGetLocalSitemap } from 'api/graphql-helper';
import { Head } from 'modules/head/head';
import Layout from 'modules/layout/layout';
import { BaseModule } from 'modules/base-module/base-module';
import IntroHeader from 'modules/intro-header/intro-header';
import { Sitemap } from 'modules/sitemap';
import { ROUTES } from 'constants/routes';
import { ISitemapPage } from 'modules/sitemap/generate-sitemap/page-data-to-sitemap-xml';
import { generateSitemap } from 'modules/sitemap/generate-sitemap/generate-sitemap';

const SitemapPage = ({ pageInformation, sitemap, ...rest }: GetLocalSitemapQuery): React.JSX.Element => {
	if (
		!pageInformation?.data?.attributes?.seo ||
		!pageInformation?.data?.attributes?.navbar ||
		!pageInformation?.data?.attributes?.footer
	)
		return <></>;

	const headerDefaultOptions = {
		backgroundColor: sitemap?.data?.attributes?.header
			?.backgroundColor as Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
		padding: 'none' as Enum_Componentinternaldefaultmoduleoptions_Padding
	};

	// TODO: fix sitemap
	return (
		<Layout navbar={pageInformation.data?.attributes?.navbar} footer={pageInformation.data?.attributes?.footer}>
			<Head seoModule={sitemap?.data?.attributes?.seo} seoParent={pageInformation.data?.attributes?.seo} />
			<BaseModule defaultModuleOptions={headerDefaultOptions}>
				<IntroHeader module={sitemap?.data?.attributes?.header} slug={ROUTES.SITEMAP.fullPath} />
			</BaseModule>
			<BaseModule>
				<Sitemap data={rest as unknown as Record<string, ISitemapPage[]>} />
			</BaseModule>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
	try {
		const { locale } = ctx;

		const pageResult = await getServerPageGetLocalSitemap(
			{
				variables: {
					locale
				}
			},
			client
		);

		const sitemap = await generateSitemap({ context: ctx, domain: 'gelderland' });

		return {
			// Merge static and dynamic pages in single object
			props: { ...pageResult.props.data, ...sitemap }
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in sitemap', error);

		return {
			notFound: true
		};
	}
};

export default SitemapPage;
